export default "__VITE_ASSET__CpK_Qo9U__"